import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateDownloadFinancialAccountStatement } from '../../models/useMutateDownloadFinancialAccountStatement'

export const useDownloadFinancialAccountStatementPresenter = ({
  financialAccountId,
  datePeriod,
  onSuccess,
}: {
  financialAccountId: number
  datePeriod: Nullable<string>
  onSuccess: () => void
}) => {
  const intl = useProcurifyIntl()
  const { mutateAsync, isLoading } =
    useMutateDownloadFinancialAccountStatement()

  const downloadStatement = async () => {
    if (!datePeriod) return

    try {
      await mutateAsync({ financialAccountId, datePeriod })

      toast.success({
        title: intl.formatMessage(messages.successToastTitle),
      })

      onSuccess()
    } catch {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
      })
    }
  }

  return {
    commands: {
      downloadStatement,
    },
    states: {
      isDownloading: isLoading,
      isDownloadDisabled: !datePeriod,
    },
  }
}
